import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-green-50" data-id="element-79">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-10 md:p-16 text-center border-2 border-brand-dark shadow-xl sm:shadow-2xl relative overflow-hidden" data-id="element-81">
          <div className="absolute top-0 left-0 w-full h-1.5 sm:h-2 bg-brand-accent" data-id="element-82"></div>

          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-24 sm:h-24 bg-brand-dark rounded-full mb-4 sm:mb-8 shadow-lg border-2 sm:border-4 border-white" data-id="element-83">
            <ShieldCheck className="w-8 h-8 sm:w-12 sm:h-12 text-brand-accent" data-id="element-84" />
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-brand-dark mb-3 sm:mb-6" data-id="element-85">
            7 DÍAS — GARANTÍA TOTAL
          </h2>
          <p className="text-base sm:text-xl font-bold text-brand-accentHover mb-4 sm:mb-8" data-id="element-86">
            7 días para probarlo o te devolvemos el 100% de tu dinero.
          </p>

          <p className="text-sm sm:text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-87">
            Descargás los tomos, revisás las cláusulas del escudo comercial y
            aplicás las plantillas de Canva. Si considerás que este sistema no
            te ahorra horas de trabajo y no te ayuda a cerrar tu próxima obra:
            nos mandás un mail y te reembolsamos el total del dinero. Sin
            preguntas, sin formularios, sin dramas.{' '}
            <span className="font-bold text-brand-dark block sm:inline mt-2 sm:mt-0" data-id="element-88">
              (Tasa de devoluciones &lt; 1%)
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}